import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const CreateBrand = async (payload) => {
  try {
    const response = await APIs.post('/create_brand', payload);

    if (response?.data?.message === 'success') {
      toast('Created Successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllBrand = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_brand/${payload.page}/${payload.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllMajorBrand = async () => {
  try {
    const response = await APIs.get(`/get_all_major_brand`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadBrandImage = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadBrandIcon = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const DeleteBrand = async (payload) => {
  try {
    const response = await APIs.post(`/delete_brand`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully deleted');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleBrandDetails = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_brand/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const EditBrand = async (payload) => {
  try {
    const response = await APIs.patch(`/edit_brand/${payload?._id}`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const SearchForBrandByName = async (payload) => {
  try {
    const response = await APIs.get(
      `/search_for_brand_by_name/${payload?.name}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const BrandServices = {
  CreateBrand,
  getAllBrand,
  getAllMajorBrand,
  uploadBrandImage,
  uploadBrandIcon,
  DeleteBrand,
  getSingleBrandDetails,
  EditBrand,
  SearchForBrandByName,
};

export default BrandServices;
